export const CaseRecord = {
    publicationQuestionTypes : {
        TEXT : 1,
        MULTI : 2
    }
}